import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { BalanceProvider } from './contexts/BalanceContext';
import { Routes } from './components/Routes';
import { MainLayout } from './components/layout/MainLayout';
import { initializeGA } from './utils/analytics';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    initializeGA();
  }, []);

  return (
    <AuthProvider>
      <BalanceProvider>
        <MainLayout>
          <Routes />
        </MainLayout>
      </BalanceProvider>
    </AuthProvider>
  );
}

export default App;